module.exports = __webpack_public_path__ + "img/tab1.491c2398.png";